import { isAxiosError } from 'axios';

export type VLANReadRefusal = {
  kind: 'target_denied' | 'address_unresolved' | 'busy' | 'unavailable';
  retryAfterSeconds: number | undefined;
};

function boundedRetryAfter(header: unknown): number | undefined {
  if (typeof header !== 'string' || !/^[1-9]\d{0,3}$/.test(header)) return undefined;
  const seconds = Number(header);
  return seconds <= 3600 ? seconds : undefined;
}

/** The code, never the backend message, controls the operator-facing explanation. */
export function vlanReadRefusal(error: unknown): VLANReadRefusal | null {
  if (!isAxiosError(error)) return null;
  const status = error.response?.status;
  const data: unknown = error.response?.data;
  if (data === null || typeof data !== 'object' || !('error' in data)) return null;
  const code = data.error;
  if (status === 422 && code === 'direct_snmp_target_denied') {
    return { kind: 'target_denied', retryAfterSeconds: undefined };
  }
  if (status === 422 && code === 'vlan_address_unresolved') {
    return { kind: 'address_unresolved', retryAfterSeconds: undefined };
  }
  if (status === 429 && code === 'vlan_admission_busy') {
    const headers = error.response?.headers;
    return { kind: 'busy', retryAfterSeconds: boundedRetryAfter(headers?.['retry-after'] ?? headers?.['Retry-After']) };
  }
  if (status === 503 && code === 'vlan_admission_unavailable') {
    return { kind: 'unavailable', retryAfterSeconds: undefined };
  }
  return null;
}

export function retryVLANQuery(failureCount: number, error: unknown): boolean {
  return vlanReadRefusal(error) === null && failureCount < 3;
}

/** The refused key stays dormant until a manual refetch or a changed query key. */
export function vlanQueryEnabled(requested: boolean, error: unknown): boolean {
  return requested && vlanReadRefusal(error) === null;
}
